import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: {
        "content-class": "popup-map",
        "data-qa": "popup_map_popup_container",
      },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.closeModalWithBackHistory.apply(null, arguments)
        },
      },
      model: {
        value: _vm.isVisibleModal,
        callback: function ($$v) {
          _vm.isVisibleModal = $$v
        },
        expression: "isVisibleModal",
      },
    },
    [
      _c(
        VBtn,
        {
          staticClass:
            "branding-btn branding-btn--primary-icon bg-gray-0 popup-map__close-button",
          attrs: {
            color: "primary",
            icon: "",
            width: "32",
            height: "32",
            "data-qa": "popup_map_close_button",
          },
          on: { click: _vm.closeModalWithBackHistory },
        },
        [
          _c(VIcon, { attrs: { size: "20" } }, [
            _vm._v("\n      ui-icon-close-not-a-circle\n    "),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "h-100 bg-gray-0",
        attrs: { id: _vm.mapId, "data-qa": "popup_map_map_container" },
      }),
      _vm._v(" "),
      _c("PopupDepartureAddressDesktop", {
        attrs: {
          "is-visible": _vm.isVisibleDepartureAddressPopup,
          "bounds-available-routes": _vm.boundsAvailableRoutes,
          "arrival-address": _vm.getArrivalAddress,
        },
        on: {
          "popup-departure-address:close": _vm.closeDepartureAddressPopup,
          "popup-departure-address:create-multi-route":
            _vm.createMultiRouteInstance,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }